module.exports = __webpack_public_path__ + "img/mx.750d3379.jpg";